import { ServiceType } from '../enums/service-type';

export function shouldShowPaymentButton(config: any, now: Date = new Date()): boolean {
  const result = config?.result;
  if (result?.service?.type === ServiceType.ONBOARDING) {
    return false;
  }

  const customerHasPlan = result?.customerHasPlan;
  if (!customerHasPlan) {
    return true;
  }

  if (customerHasPlan.status_customerPlan !== 1) {
    return true;
  }

  return new Date(customerHasPlan.next_bill_date) <= now;
}

export function shouldShowPaymentButtonForPortal(portal: any, now: Date = new Date()): boolean {
  if (portal?.service?.type === ServiceType.ONBOARDING) {
    return false;
  }

  return shouldShowPaymentButton({ result: portal }, now);
}

export function canUsePortalService(portal: any): boolean {
  if (portal?.service?.type === ServiceType.ONBOARDING) {
    return portal?.service?.status_service === 1;
  }

  return portal?.customerHasPlan != null && portal.customerHasPlan.status_customerPlan === 1;
}

export function isInactiveOnboardingPortal(portal: any): boolean {
  return portal?.service?.type === ServiceType.ONBOARDING
    && portal?.service?.status_service === 2;
}
